<div class="page-container">
  <ciphr-navigation />

  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
